export default "__VITE_ASSET__usZJ9Unb__"